import { render, staticRenderFns } from "./LobbyChat.vue?vue&type=template&id=fa7a2a0e&scoped=true&"
import script from "./LobbyChat.vue?vue&type=script&lang=js&"
export * from "./LobbyChat.vue?vue&type=script&lang=js&"
import style0 from "./LobbyChat.vue?vue&type=style&index=0&id=fa7a2a0e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7a2a0e",
  null
  
)

component.options.__file = "LobbyChat.vue"
export default component.exports